import { RegexValidator } from './regex';

export function LettersOnlyValidator(customMsg?: string) {
  return RegexValidator(/^[a-zA-Z ]*$/, customMsg || 'This field contains invalid characters');
}
